class Search {
    constructor() {
        this._init()
    }
    _init() {
        this.el = document.querySelector('[data-search]')
        if(!this.el) {
            return
        }
        this.elResults = this.el.querySelectorAll('[data-search-results]')
        this.count = 0
        this.elResults.forEach(el => {
            el.display = new Display(el, this.el, this)
            el.elElements = el.querySelectorAll('[data-search-element]')
            el.elElements.forEach(El => {
                El.element = new Element(El, el.display, this.el)
            })
            el.display.setEvent()
        })
        this.elAction = this.el.querySelector('[data-search-action]')
        this.elAction.addEventListener('input', () => this.onInput())
        this.elSubmit = this.el.querySelector('[data-search-form]')
        this.elSubmit.addEventListener('submit', (e) => this.onSubmit(e))
        this.elEmpty = this.el.querySelector('[data-search-empty]')
        if(this.elEmpty) {
            this.elActionFill = this.elEmpty.querySelector('[data-search-action-fill]')
            this.elEmpty.style.display = 'none'
        }
    }
    onInput() {
        let input = new Event('searchinput')
        let value = ""
        this.elAction.value.split('.').forEach(element => {
            value += element
        })
        input.value = value
        this.elActionFill.innerText = value + "."
        let params = Array.from(value)
        let regex = params[0] ? "" + params[0] : "" 
        for(let i = 1; i < params.length; i++) {
            regex += ".*" + params[i]
        }
        input.regex =  new RegExp(regex, "i")
        this.el.dispatchEvent(input)
    }
    incrementCount(b) {
        this.count += b
        if(!this.elEmpty) {
            return 
        }
        if(this.count == 0) {
            this.elEmpty.style.display = ""
        } else if(this.count > 0) {
            this.elEmpty.style.display = "none"
        } 
    }
    onSubmit(e) {
        e.preventDefault()
        if(this.elAction.value.length > 0) {
            const el = this.getFirstResult()
            if(!el) {
                return
            }
            el.focus()
            el.click()
        }
    }
    getFirstResult() {
        for(let i = 0; i < this.elResults.length; i++) {
            if(!this.elResults[i].display.hidden) {
                return this.elResults[i].display.getFirstResult()
            }
        }
    }
}

class Display {
    constructor(el, listener, search) {
        this._init(el, listener, search)
    }
    _init(el, listener, search) {
        this.el = el
        this.listener = listener
        this.childrenCount = 0
        this.hidden = false
        this.search = search
        this.search.incrementCount(1)
    }
    setEvent() {
        this.listener.addEventListener('searchinput', (e) => this.onSearchInput(e))
    }
    onSearchInput(e) {
        if(!this.isMobile() || e.value.length != 0){
            this.el.open = true;
        } else {
            this.el.open = false;
        }
        if(this.childrenCount == 0) {
            this.el.style.display = "none"
            if(!this.hidden) {
                this.search.incrementCount(-1)
                this.hidden = true
            }
        } else if(this.childrenCount > 0) {
            this.el.style.display = ""
            if(this.hidden) {
                this.search.incrementCount(1)
                this.hidden = false
            }
        } 
    }
    addToCount(c) {
        this.childrenCount += c
    }    
    getFirstResult() {
        for(let i = 0; i < this.el.elElements.length; i++) {
            if(!this.el.elElements[i].element.hidden) {
                return this.el.elElements[i]
            }
        }
    }
	isMobile() {
		return !window.matchMedia("only screen and (min-width: 1024px)").matches
	}
} 

class Element {
    constructor(el, display, listener) {
        this._init(el, display, listener)
    }
    _init(el, display, listener) {
        this.el = el
        this.elParam = this.el.querySelector('[data-search-param]')
        this.parameter = this.elParam.innerText
        this.parameters = Array.from(this.elParam.innerText)
        listener.addEventListener('searchinput', (e) => this.onSearchInput(e))
        this.hidden = false
        this.display = display
        this.display.addToCount(1)
    }
    onSearchInput(e) {
        if(e.regex.test(this.parameter)) {
            this.el.style.display = ""
            if(this.hidden) {
                this.display.addToCount(1)
                this.hidden = false
            }
            this.elParam.innerHTML = ""
            this.elParam.appendChild(this.highlightSearchParams(e.value))
        } else {
            this.el.style.display = "none"
            if(!this.hidden) {
                this.display.addToCount(-1)
                this.hidden = true
            }
        }
    }
    highlightSearchParams(params) {
        let newElem = document.createElement('span')
        const mParams = Array.from(params.toLowerCase())
        let index = 0
        for(let i = 0; i < this.parameters.length; i++) {
            let append = this.parameters[i]
            if(index < mParams.length && append.toLowerCase() == mParams[index]) {
                append = this.getFormattedHTML(append)
                index++
                newElem.appendChild(append)
                continue
            }
            newElem.innerHTML += append
        }
        return newElem
    }
    getFormattedHTML(string) {
        let newElem = document.createElement('span')
        let text = document.createTextNode(string)
        newElem.appendChild(text)
        newElem.classList.add('text--highlight')
        return newElem
    }
}

export default Search